export default __webpack_public_path__ + "images/0xe5da20f15420ad15de0fa650600afc998bbe3955.png";